import { signal } from "@preact/signals-react"

export const infoModalRowClick = signal({})
export const isOpenInfo = signal(false)